// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"index_modalWrapper__3oege","error":"index_error__1gN5Z","note":"index_note__3Tv7H"};